var exports = {
  "kL": "GuildRolesTab.module__container___TkszME",
  "pG": "GuildRolesTab.module__right___TkszME",
  "ze": "GuildRolesTab.module__rightScroller___TkszME",
  "CI": "GuildRolesTab.module__sectionRow___TkszME",
  "bV": "GuildRolesTab.module__sectionHeader___TkszME",
  "Gf": "GuildRolesTab.module__sectionTitle___TkszME",
  "bQ": "GuildRolesTab.module__subtleText___TkszME",
  "u2": "GuildRolesTab.module__sectionSubtitle___TkszME",
  "Zv": "GuildRolesTab.module__displayRow___TkszME",
  "yD": "GuildRolesTab.module__nameField___TkszME",
  "IV": "GuildRolesTab.module__colorField___TkszME",
  "h3": "GuildRolesTab.module__settingsGroup___TkszME",
  "Fs": "GuildRolesTab.module__permSearchRow___TkszME",
  "XZ": "GuildRolesTab.module__permSearchInput___TkszME",
  "sN": "GuildRolesTab.module__layoutButtons___TkszME",
  "Zh": "GuildRolesTab.module__layoutButton___TkszME",
  "HU": "GuildRolesTab.module__permCategories___TkszME",
  "cy": "GuildRolesTab.module__permHeaderRow___TkszME",
  "mA": "GuildRolesTab.module__permHelp___TkszME",
  "p$": "GuildRolesTab.module__emptyState___TkszME",
  "EK": "GuildRolesTab.module__itemWrap___TkszME",
  "hW": "GuildRolesTab.module__roleButton___TkszME",
  "cB": "GuildRolesTab.module__dragging___TkszME",
  "mG": "GuildRolesTab.module__noDrag___TkszME",
  "hz": "GuildRolesTab.module__lockIcon___TkszME",
  "s4": "GuildRolesTab.module__leftTitle___TkszME",
  "rV": "GuildRolesTab.module__overwriteItem___TkszME",
  "w7": "GuildRolesTab.module__overwriteItemSelected___TkszME",
  "MJ": "GuildRolesTab.module__overwriteItemHovered___TkszME",
  "m4": "GuildRolesTab.module__roleDot___TkszME",
  "l": "GuildRolesTab.module__overwriteName___TkszME",
  "xF": "GuildRolesTab.module__mobileRoleList___TkszME",
  "E_": "GuildRolesTab.module__mobileListHeader___TkszME",
  "JJ": "GuildRolesTab.module__mobileListTitle___TkszME",
  "W4": "GuildRolesTab.module__mobileRoles___TkszME",
  "eu": "GuildRolesTab.module__mobileRoleItem___TkszME",
  "Mt": "GuildRolesTab.module__mobileRoleName___TkszME",
  "eP": "GuildRolesTab.module__mobileRoleChevron___TkszME",
  "yg": "GuildRolesTab.module__mobileBackRow___TkszME",
};

module.exports = exports;
